import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ArtifactVM,
  SoftwareSelectionResolutionDto,
} from 'src/app/models/device.model';
import {
  ReleaseBundleArtifactDto,
  ReleaseBundleDto,
} from 'src/app/models/license.model';
import { SoftwareOverrideComponent } from '../device-software-override.types';

export interface ArtifactSelectionEvent {
  component: SoftwareOverrideComponent;
  artifact: ArtifactVM | string;
}

export interface BundleArtifactSource {
  bundle: ReleaseBundleDto;
  artifact: ReleaseBundleArtifactDto;
}

@Component({
  selector: 'app-device-artifact-override-section',
  templateUrl: './device-artifact-override-section.component.html',
  styleUrl: './device-artifact-override-section.component.scss',
  standalone: false,
})
export class DeviceArtifactOverrideSectionComponent {
  @Input() components: SoftwareOverrideComponent[] = [];
  @Input() bundleOverrides: ReleaseBundleDto[] = [];
  @Input() softwareSelectionResolutions: SoftwareSelectionResolutionDto[] = [];
  @Input() forLicenseBatch = false;
  @Input() unresolvedOverrideIds: string[] = [];
  @Input() saving = false;

  @Output() artifactOverrideRequested =
    new EventEmitter<SoftwareOverrideComponent>();
  @Output() artifactOverrideCancelled =
    new EventEmitter<SoftwareOverrideComponent>();
  @Output() artifactSelected = new EventEmitter<ArtifactSelectionEvent>();
  @Output() artifactCleared = new EventEmitter<SoftwareOverrideComponent>();
  @Output() artifactsRequested = new EventEmitter<SoftwareOverrideComponent>();

  isUnresolved(artifact: ArtifactVM): boolean {
    return this.unresolvedOverrideIds.includes(artifact.id);
  }

  get componentProjectIds(): string[] {
    return this.components.map((component) => component.id);
  }

  getBundleArtifactSources(
    component: SoftwareOverrideComponent,
  ): BundleArtifactSource[] {
    return this.bundleOverrides
      .flatMap((bundle) =>
        (bundle.artifacts ?? [])
          .filter((artifact) => artifact.projectId === component.id)
          .map((artifact) => ({ bundle, artifact })),
      )
      .sort((first, second) =>
        first.bundle.name.localeCompare(second.bundle.name),
      );
  }
}
